import { render, staticRenderFns } from "./ResetOtpAttemptsDialog.vue?vue&type=template&id=d492f4a8"
import script from "./ResetOtpAttemptsDialog.vue?vue&type=script&lang=js"
export * from "./ResetOtpAttemptsDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetOtpAttemptsDialog.vue?vue&type=style&index=0&id=d492f4a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports